// newformBuilderPopup.js
import React, { useState, useEffect } from 'react';
import './NewFormPopup.css';
import { generateSlug } from '../helpers/generateSlug.js'
import { saveForm } from '../APIS/formsAPI';
import { showError, showWarning } from '../helpers/notifications';
import { useSelector } from 'react-redux';

const NewFormPopup = ({ onSave, onClose}) => {
  const [formtitle, setFormTitle] = useState('')
  const [formdesc, setFormDesc] = useState('')
  const [formsaved,setFormSaved] = useState(false);

  const token = useSelector((state) => state.auth.token);
  const userid = useSelector((state) => state.auth._id);

  useEffect(()=>{
    async function addNewForm() {
      const slug = generateSlug(formtitle);
      setFormSaved(false)
      const formData = {
        title: formtitle,
        description: formdesc,
        slug,
        json_definition: {},
        id: null,
        createdby: userid,
      }
      try {
        const result = await saveForm(formData, token);
        if (result.status) {
          onSave(result.id)
        } else {
          showError(`Error: ${result.error}`);
        }
      } catch(err) {
        showError(`There was an Error Creating a New Form: ${err.message}`)
      }
    }
    if(formsaved) {
      if((formtitle??'') === '') {
        showWarning("You cannot save the Form without giving it a title. Please add a Title then re-save.");
        return;
      }
      if((formdesc??'') === '') {
        showWarning("You cannot save the Form without giving it a description. Please add a Description then re-save.");
        return;
      }
      // We have the Info so lets add a new form
      addNewForm()
    }
  },[formsaved, formtitle, formdesc, token, userid, onSave])

  const addForm = () => { setFormSaved(true) }

  const closeForm = () => {
    let text = ''
    if(formtitle > "")
      text += `A Title of ${formtitle}`
    if(formdesc > "")
      text += `A Description of ${formtitle}`
    if(text > "") {
      if(window.confirm(`You have added the following data and it has not been saved. By Closing this Form you will lose  the following changes.\n${text}\nAre You Sure you Wish to Close the Form?`))
      {
        onClose();
        return;
      }
    }
  }
  return (
    <div className="newform-popup">
      <div className="newform-popup-header">
        <h3>Add New Form</h3>
        <button onClick={() => {closeForm();}} className="close-btn">×</button>
      </div>

      <div className="newform-popup-body">
        <label className='label' htmlFor='title'>Enter Title</label>
        <input className='textinput' type='text' id='title' name='title' value={formtitle} onChange={(e) => setFormTitle(e.target.value)} />
        <label className='label'  htmlFor='desc'>Enter Description</label>
        <input className='textinput'  type='text' id='desc' name='desc' value={formdesc} onChange={(e) => setFormDesc(e.target.value)} />

      </div>

      <div className="newform-popup-footer">
        <button onClick={() => addForm()} className="save-btn">Save New Form</button>
      </div>
    </div>
  );
};

export default NewFormPopup;
